import { createSlice } from '@reduxjs/toolkit'

interface TransactionState {
    data: any[]
    loading: boolean
}

const initialState: TransactionState = {
    data: [],
    loading: false
}

const transactionSlice = createSlice({
    name: 'analysis',
    initialState: initialState,
    reducers: {
        setTransactionData: (state, action) => {
            state.data = action.payload
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        }
    }
})

export const { setTransactionData, setLoading } = transactionSlice.actions
export default transactionSlice.reducer
